import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { id: "app" };
const _hoisted_2 = { class: "navbar navbar-expand-lg navbar-dark bg-primary" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = {
    id: "navbarNav",
    class: "collapse navbar-collapse"
};
const _hoisted_5 = { class: "navbar-nav me-auto" };
const _hoisted_6 = { class: "nav-item" };
const _hoisted_7 = { class: "nav-item" };
const _hoisted_8 = { class: "nav-item" };
const _hoisted_9 = { class: "navbar-nav" };
const _hoisted_10 = {
    key: 0,
    class: "nav-item"
};
const _hoisted_11 = {
    key: 1,
    class: "nav-item"
};
const _hoisted_12 = {
    key: 2,
    class: "nav-item dropdown"
};
const _hoisted_13 = {
    class: "nav-link dropdown-toggle",
    href: "#",
    role: "button",
    "data-bs-toggle": "dropdown"
};
const _hoisted_14 = { class: "dropdown-menu" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { key: 1 };
const _hoisted_17 = { key: 2 };
const _hoisted_18 = { key: 3 };
const _hoisted_19 = { key: 4 };
const _hoisted_20 = { class: "container mt-4" };
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const isAuthenticated = computed(() => store.getters.isAuthenticated);
        const isEmailVerified = computed(() => store.getters.isEmailVerified);
        const user = computed(() => store.getters.user);
        const logout = () => {
            store.dispatch('logout');
            router.push('/');
        };
        //if auto reload do comment this code
        onMounted(() => {
            if (localStorage.getItem('token')) {
                store.dispatch('checkAuth');
            }
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("nav", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_router_link, {
                            class: "navbar-brand",
                            to: "/"
                        }, {
                            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("strong", null, "SmartRMA", -1)
                                ]))]),
                            _: 1
                        }),
                        _cache[12] || (_cache[12] = _createElementVNode("button", {
                            class: "navbar-toggler",
                            type: "button",
                            "data-bs-toggle": "collapse",
                            "data-bs-target": "#navbarNav"
                        }, [
                            _createElementVNode("span", { class: "navbar-toggler-icon" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("ul", _hoisted_5, [
                                _createElementVNode("li", _hoisted_6, [
                                    _createVNode(_component_router_link, {
                                        class: "nav-link",
                                        to: "/"
                                    }, {
                                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                _createTextVNode(" Home ", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("li", _hoisted_7, [
                                    _createVNode(_component_router_link, {
                                        class: "nav-link",
                                        to: "/request"
                                    }, {
                                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                _createTextVNode(" Submit RMA ", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ]),
                                _createElementVNode("li", _hoisted_8, [
                                    _createVNode(_component_router_link, {
                                        class: "nav-link",
                                        to: "/status"
                                    }, {
                                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                                _createTextVNode(" Check Status ", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ])
                            ]),
                            _createElementVNode("ul", _hoisted_9, [
                                (!isAuthenticated.value)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                        _createVNode(_component_router_link, {
                                            class: "nav-link",
                                            to: "/signup"
                                        }, {
                                            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                                    _createTextVNode(" Sign Up ", -1)
                                                ]))]),
                                            _: 1
                                        })
                                    ]))
                                    : _createCommentVNode("", true),
                                (!isAuthenticated.value)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                                        _createVNode(_component_router_link, {
                                            class: "nav-link",
                                            to: "/login"
                                        }, {
                                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                                    _createTextVNode(" Admin Login ", -1)
                                                ]))]),
                                            _: 1
                                        })
                                    ]))
                                    : _createCommentVNode("", true),
                                (isAuthenticated.value && user.value)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                                        _createElementVNode("a", _hoisted_13, _toDisplayString(user.value.username), 1),
                                        _createElementVNode("ul", _hoisted_14, [
                                            (user.value.role === 'admin')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                                                    _createVNode(_component_router_link, {
                                                        class: "dropdown-item",
                                                        to: "/admin"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                                _createTextVNode(" Admin Panel ", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]))
                                                : _createCommentVNode("", true),
                                            (user.value.role === 'subscriber')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                                                    _createVNode(_component_router_link, {
                                                        class: "dropdown-item",
                                                        to: "/subscriber"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                                _createTextVNode(" Subscriber Panel ", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]))
                                                : _createCommentVNode("", true),
                                            (user.value.role === 'subscriber')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                                    _createVNode(_component_router_link, {
                                                        class: "dropdown-item",
                                                        to: "/credential"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                                _createTextVNode(" Store Credential Settings ", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]))
                                                : _createCommentVNode("", true),
                                            (user.value.role === 'subscriber')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                                                    _createVNode(_component_router_link, {
                                                        class: "dropdown-item",
                                                        to: "/format"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                                _createTextVNode(" Policy Format Settings ", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]))
                                                : _createCommentVNode("", true),
                                            (user.value.role === 'subscriber' || user.value.role === 'admin')
                                                ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                                                    _createVNode(_component_router_link, {
                                                        class: "dropdown-item",
                                                        to: "/subscriber/merchant-policy"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                                _createTextVNode(" Merchant Policy Settings ", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]))
                                                : _createCommentVNode("", true),
                                            _cache[11] || (_cache[11] = _createElementVNode("li", null, [
                                                _createElementVNode("hr", { class: "dropdown-divider" })
                                            ], -1)),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("a", {
                                                    class: "dropdown-item",
                                                    href: "#",
                                                    onClick: logout
                                                }, "Logout")
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("main", _hoisted_20, [
                    _createVNode(_component_router_view)
                ]),
                _cache[13] || (_cache[13] = _createStaticVNode("<footer class=\"bg-light mt-5 py-4\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-6\"><h5>SmartRMA</h5><p class=\"text-muted\"> Return Management System </p></div><div class=\"col-md-6\"><h5>Contact Us</h5><p class=\"text-muted\"> Email: Sales@kasernet.com<br> Tel : (510)4026270 </p></div></div></div></footer>", 1))
            ]));
        };
    }
});
